import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import type { MyTenant } from "./api.js";

export function useTenantPath() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  return (path: string) => `/${tenantSlug}/${path}`;
}

export function useTenantPublicBase() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  if (import.meta.env.DEV) return "http://localhost:5173";
  const qc = useQueryClient();
  const tenants = qc.getQueryData<MyTenant[]>(["my-tenants"]);
  const tenant = tenants?.find((t) => t.slug === tenantSlug);
  if (tenant?.custom_domain) return `https://${tenant.custom_domain}`;
  return `https://${tenantSlug}.templestay.app`;
}
